import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonGroup, ButtonList, DropdownButton, DropdownButtonContext, } from '@dixa/lib-shared-habla';
import { analytics } from 'app/utils/segment';
import { composeEmailActions } from 'components/shared/composeEmail/actions/composeEmailActions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import styles from './contactEmail.module.scss';
export function ContactEmailAction({ user, }) {
    const dispatch = useAppDispatch();
    const handleClick = (email) => {
        if (!email)
            return;
        const toUser = [
            {
                user: Object.assign(Object.assign(Object.assign({}, user), (user.name && { display_name: user.name })), (email && { email })),
            },
        ];
        // Dispatch in next animation frame to avoid blur when the modal is opened
        requestAnimationFrame(() => {
            dispatch(composeEmailActions.composeEmailOpenModal({
                initialValues: { toUser },
            }));
        });
        analytics.contactsCardComposeNewEmailClicked();
    };
    return (_jsxs(ButtonGroup, Object.assign({ variant: "secondary" }, { children: [_jsx(Button, Object.assign({ icon: "mail", onClick: () => handleClick(user.email) }, { children: "Email" })), user.additional_emails && (_jsx(DropdownButton, { icon: "angle-down", buttonProps: {
                    className: styles.dropdownButton,
                }, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => {
                        var _a;
                        return (_jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ onClick: () => {
                                        toggleDropdown();
                                        handleClick(user.email);
                                    } }, { children: user.email })), (_a = user.additional_emails) === null || _a === void 0 ? void 0 : _a.map((option) => (_jsx(ButtonList.Item, Object.assign({ onClick: () => {
                                        toggleDropdown();
                                        handleClick(option);
                                    } }, { children: option }), option)))] }));
                    } }) }))] })));
}
